import { connect } from 'react-redux';
import { toggleFlatFilterAction } from '../actions/mvk_state';
import { FlatTypeFilter } from '../components/flat_type_filter';
import { getFlatTypesInFloor } from '../utils/parsers/flats';
export var FlatTypeFilterContainer = connect(function (state) {
  var MVKData = state.MVKData,
    _state$MVKState = state.MVKState,
    house = _state$MVKState.house,
    isOfferCard = _state$MVKState.isOfferCard,
    section = _state$MVKState.section,
    _state$MVKState$secti = _state$MVKState.sectionPhaseFilters,
    selectedFlatTypes = _state$MVKState$secti.selectedFlatTypes,
    selectedFloor = _state$MVKState$secti.selectedFloor;
  return {
    floorFlatTypes: getFlatTypesInFloor(MVKData, house.id, section.id, selectedFloor),
    selectedFlatTypes: selectedFlatTypes || [],
    isOfferCard: isOfferCard
  };
}, function (dispatch) {
  return {
    toggleFlatFilter: function toggleFlatFilter(flatType) {
      return dispatch(toggleFlatFilterAction(flatType));
    }
  };
})(FlatTypeFilter);